import React, { useState } from "react";
import {
  Box,
  Button,
  HStack,
  Input,
  Radio,
  RadioGroup,
  Text,
  VStack,
} from "@chakra-ui/react";

export function SelectActionWidget({ prompt, options = [], onSend }) {
  const [selected, setSelected] = useState(null);
  const [note, setNote] = useState("");
  const [submitted, setSubmitted] = useState(null);

  const canSubmit = selected !== null || note.trim().length > 0;

  const handleSubmit = () => {
    if (!canSubmit) return;
    let msg = "";
    if (selected && note.trim()) msg = `${selected}. ${note.trim()}`;
    else if (selected) msg = selected;
    else msg = note.trim();
    setSubmitted(msg);
    onSend(msg);
  };

  if (submitted) {
    return (
      <Box bg="gray.50" borderWidth="1px" borderRadius="md" p={3} my={2}>
        <Text fontSize="xs" color="gray.500" mb={1}>
          {prompt}
        </Text>
        <Text fontSize="sm">✓ {submitted}</Text>
      </Box>
    );
  }

  return (
    <Box bg="white" borderWidth="1px" borderRadius="md" p={3} my={2}>
      <Text fontSize="sm" fontWeight="medium" mb={2}>
        {prompt}
      </Text>
      <RadioGroup value={selected ?? ""} onChange={setSelected}>
        <VStack align="stretch" spacing={1}>
          {options.map((opt) => (
            <Radio key={opt} value={opt} size="sm">
              <Text fontSize="sm">{opt}</Text>
            </Radio>
          ))}
        </VStack>
      </RadioGroup>
      <Input
        mt={2}
        size="sm"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Something else? Type here..."
      />
      <HStack mt={2}>
        <Button size="sm" variant="primary" onClick={handleSubmit} isDisabled={!canSubmit}>
          Submit
        </Button>
      </HStack>
    </Box>
  );
}
